import {useOrders} from './useOrders';

export default useOrders;
